import { Assets, Container, Graphics, Renderer, Sprite, Texture } from 'pixi.js';

import { getResizeUri } from 'app/utils/image';

import { AVATAR_IMAGE_SIZE, COLORS, PLAYER_SIZE } from '../constants';

import { addBlur } from './player-components/player.helper';

export const createAvatarSprite = async (pixiFilters: boolean, imageURI?: string): Promise<Container> => {
  let imageTexture: Texture = Texture.EMPTY;
  const profileImageURI = imageURI ? getResizeUri({ uri: imageURI, width: AVATAR_IMAGE_SIZE }) : undefined;
  const scale = PLAYER_SIZE / AVATAR_IMAGE_SIZE;
  let avatarSprite: Sprite = new Sprite();
  avatarSprite.anchor.set(0.5, 0.5);
  avatarSprite.scale.set(scale, scale);
  const avatarContainer = new Container();
  avatarContainer.name = 'avatar-container';
  if (profileImageURI) {
    imageTexture = await Assets.load(profileImageURI);

    // FIXME: why are we redeclaring here?
    avatarSprite = new Sprite(imageTexture);
    avatarSprite.interactiveChildren = false;
    avatarSprite.eventMode = 'none';
    avatarSprite.anchor.set(0.5, 0.5);

    const circleMaskRadius = 110;
    const circleMask = new Graphics();
    circleMask.beginFill(COLORS.maskColor);
    circleMask.drawCircle(0, 0, circleMaskRadius);
    circleMask.endFill();

    avatarContainer.mask = circleMask;
    avatarContainer.addChild(avatarSprite, circleMask);
  } else {
    avatarContainer.visible = false;
  }

  // Apply blur to avatar sprite
  addBlur(avatarSprite, pixiFilters);
  return avatarContainer;
};
